import type { Category } from './categories';

export interface VideoArticle {
  id: string;
  title: string;
  slug: string;
  description: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  tags: string[];
  author: string;
  publishDate: string;
  viewCount: number;
  likeCount: number;
  duration: string;
  contentHtml: string;
  isHot: boolean;
  isNew: boolean;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '恋爱日常',
    slug: 'lianai-richang',
    description: '记录甜蜜恋爱中的点点滴滴',
    icon: 'ri-heart-line',
    color: 'primary',
  },
  {
    id: 'cat-2',
    name: '甜蜜互动',
    slug: 'tianmi-hudong',
    description: '情侣间的温暖有趣互动瞬间',
    icon: 'ri-user-heart-line',
    color: 'secondary',
  },
  {
    id: 'cat-3',
    name: '趣味搞笑',
    slug: 'quwei-gaoxiao',
    description: '让你捧腹大笑的搞笑短视频',
    icon: 'ri-emotion-laugh-line',
    color: 'accent',
  },
  {
    id: 'cat-4',
    name: '搞怪萌宠',
    slug: 'gaoguai-mengchong',
    description: '可爱宠物们的搞笑日常',
    icon: 'ri-bear-smile-line',
    color: 'primary',
  },
  {
    id: 'cat-5',
    name: '情感故事',
    slug: 'qinggan-gushi',
    description: '温暖人心的情感短视频故事',
    icon: 'ri-chat-heart-line',
    color: 'secondary',
  },
  {
    id: 'cat-6',
    name: '生活趣事',
    slug: 'shenghuo-qushi',
    description: '日常生活中有趣的精彩瞬间',
    icon: 'ri-sun-line',
    color: 'accent',
  },
];

export const videos: VideoArticle[] = [
  {
    id: 'video-1',
    title: '当女朋友想吃火锅却被拒绝时…男生的反应也太真实了',
    slug: 'nvpengyou-xiangchi-huoguo',
    description: '女朋友撒娇说想吃火锅，男生故意逗她的可爱反应，全程高甜！看到最后笑到肚子疼，这对情侣的日常也太有爱了吧～',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20couple%20at%20a%20hotpot%20restaurant%2C%20girlfriend%20playfully%20pouting%20while%20boyfriend%20laughs%2C%20warm%20romantic%20atmosphere%2C%20soft%20lighting%2C%20candid%20moment%2C%20editorial%20photography%20with%20shallow%20depth%20of%20field%2C%20natural%20expressions%2C%20cozy%20interior&width=800&height=450&seq=video-cover-01&orientation=landscape',
    category: '恋爱日常',
    categorySlug: 'lianai-richang',
    tags: ['恋爱', '搞笑', '火锅', '情侣日常'],
    author: '甜蜜小剧场',
    publishDate: '2026-08-10',
    viewCount: 128500,
    likeCount: 36200,
    duration: '03:25',
    contentHtml: '<p>在这个超甜的短视频里，女朋友突然撒娇说想吃火锅，男生一开始假装拒绝，逗得女朋友气鼓鼓的样子实在太可爱了！</p><p>没想到男生早就偷偷订好了她最爱的那家火锅店，还准备了小惊喜。看到女朋友从生气到惊喜的表情变化，简直甜到掉牙！</p><p>这对小情侣的日常互动让人看完忍不住嘴角上扬，评论区全是"我也想谈恋爱了"的留言～</p><p>视频中的各种细节都充满了爱意，男生偷偷记住女朋友喜欢的菜品、提前预订位置、还准备了她最爱的小甜品，这种细心的浪漫真的太让人心动了！</p>',
    isHot: true,
    isNew: false,
  },
  {
    id: 'video-2',
    title: '猫咪看到主人带新宠物回家，这反应笑死我了',
    slug: 'maomi-kandao-xinchongwu',
    description: '铲屎官带了一只小金毛回家，家里原住猫的反应简直是奥斯卡级别的表演！从震惊到吃醋再到傲娇，每一帧都是表情包。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fluffy%20orange%20tabby%20cat%20staring%20jealously%20at%20a%20small%20golden%20retriever%20puppy%2C%20living%20room%20setting%2C%20warm%20sunlight%20streaming%20through%20window%2C%20cute%20and%20funny%20pet%20scene%2C%20soft%20cozy%20home%20interior%2C%20bright%20natural%20lighting%2C%20clean%20simple%20background&width=800&height=450&seq=video-cover-02&orientation=landscape',
    category: '搞怪萌宠',
    categorySlug: 'gaoguai-mengchong',
    tags: ['猫咪', '萌宠', '搞笑', '宠物日常'],
    author: '萌宠大本营',
    publishDate: '2026-08-09',
    viewCount: 256800,
    likeCount: 89300,
    duration: '02:58',
    contentHtml: '<p>这只橘猫的表情管理堪称一绝！当主人带着新来的小金毛进门那一刻，猫咪的表情从好奇到震惊再到"你背叛了我"的委屈，简直是一部完整的情绪电影。</p><p>更搞笑的是，猫咪开始了一系列"争宠"行为：故意在小金毛面前蹭主人、用自己的身体挡住小狗的视线、甚至还试图把小金毛的玩具藏起来！</p><p>不过到了视频结尾，两个小家伙居然开始一起玩耍了，猫咪虽然还是一脸傲娇，但尾巴已经开心地摇起来了～</p><p>这个视频告诉我们，即使是高冷的猫咪，最终也会被可爱的小狗融化。评论区已经被"啊啊啊好可爱"刷屏了！</p>',
    isHot: true,
    isNew: false,
  },
  {
    id: 'video-3',
    title: '异地恋见面第一秒，这对情侣的反应看哭了无数人',
    slug: 'yidilian-jianmian-diyimiao',
    description: '异地三个月后终于见面，女生从车站跑出来的那一刻，男生的反应让所有人都破防了。这就是爱情最美好的样子吧！',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20couple%20embracing%20tightly%20at%20a%20train%20station%2C%20emotional%20reunion%20scene%2C%20girl%20running%20toward%20boy%20with%20tears%20of%20joy%2C%20warm%20golden%20sunset%20light%2C%20romantic%20atmosphere%2C%20cinematic%20composition%2C%20soft%20bokeh%20background%2C%20clean%20simple%20surroundings&width=800&height=450&seq=video-cover-03&orientation=landscape',
    category: '甜蜜互动',
    categorySlug: 'tianmi-hudong',
    tags: ['异地恋', '感动', '情侣', '重逢'],
    author: '爱情故事馆',
    publishDate: '2026-08-08',
    viewCount: 452100,
    likeCount: 128600,
    duration: '04:12',
    contentHtml: '<p>异地三个月，每天只能通过视频通话看到对方。这一天，女生坐了六个小时的高铁来到男生的城市，想要给他一个惊喜。</p><p>当女生从出站口跑出来的那一刻，男生先是一愣，然后眼眶瞬间就红了。他冲过去紧紧抱住女朋友，两个人就在人群中来了一次最温暖的拥抱。</p><p>周围的旅客都忍不住停下来微笑看着他们，还有人在旁边偷偷拍照。这种纯粹的爱情真的太美好了，让人看完心里暖暖的。</p><p>评论区最高赞的留言是："看到这个视频，我对异地恋又有信心了。真爱是可以跨越距离的。"</p>',
    isHot: true,
    isNew: false,
  },
  {
    id: 'video-4',
    title: '男生偷偷学了一个月做饭，给女朋友的生日惊喜太浪漫了',
    slug: 'nansheng-toutou-xuezuofan',
    description: '从厨房小白到能做出一桌好菜，这个男生为了女朋友的生日准备了一个月的惊喜，看到最后直接泪目！',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20man%20setting%20up%20a%20romantic%20candlelit%20dinner%20table%20with%20homemade%20dishes%2C%20warm%20candle%20glow%2C%20rose%20petals%20on%20table%2C%20cozy%20apartment%20dining%20room%2C%20intimate%20atmosphere%2C%20soft%20warm%20lighting%2C%20clean%20modern%20interior%2C%20love%20and%20care%20in%20details&width=800&height=450&seq=video-cover-04&orientation=landscape',
    category: '恋爱日常',
    categorySlug: 'lianai-richang',
    tags: ['恋爱', '生日惊喜', '做饭', '浪漫'],
    author: '甜蜜小剧场',
    publishDate: '2026-08-07',
    viewCount: 189300,
    likeCount: 56400,
    duration: '05:30',
    contentHtml: '<p>一个连煮方便面都能翻车的男生，为了给女朋友一个难忘的生日，偷偷报了一个月的烹饪课。从切菜把手切到、煎蛋煎糊、到最终能做出一桌色香味俱全的晚餐，这一个月的心路历程全被他的室友偷偷记录了下来。</p><p>生日当天，男生布置了浪漫的烛光晚餐，还亲手做了一个草莓蛋糕。当女朋友推开门看到这一切的时候，惊讶得说不出话来，然后抱着男朋友哭了起来。</p><p>她说："这是我这辈子收到的最好的生日礼物。"看完这个视频，谁不想拥有一个愿意为自己学做饭的男朋友呢？</p>',
    isHot: false,
    isNew: true,
  },
  {
    id: 'video-5',
    title: '哈士奇趁主人不在家开派对，监控拍下全程笑疯了',
    slug: 'hashiqui-kaipaidui',
    description: '主人出门后，这只哈士奇竟然召集了邻居家的狗来家里开派对！监控录像记录下了一切，看到狗子们的行为简直让人笑到岔气。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20husky%20dog%20sitting%20in%20a%20messy%20living%20room%20with%20scattered%20pillows%20and%20toys%2C%20guilty%20expression%20on%20face%2C%20bright%20daylight%20coming%20through%20window%2C%20chaotic%20but%20cute%20scene%2C%20clean%20simple%20home%20interior%2C%20humorous%20pet%20photography%2C%20natural%20light%2C%20warm%20tones&width=800&height=450&seq=video-cover-05&orientation=landscape',
    category: '搞怪萌宠',
    categorySlug: 'gaoguai-mengchong',
    tags: ['哈士奇', '萌宠', '搞笑', '监控'],
    author: '萌宠大本营',
    publishDate: '2026-08-06',
    viewCount: 387200,
    likeCount: 142500,
    duration: '04:45',
    contentHtml: '<p>这只哈士奇绝对是狗界的"派对之王"！主人刚出门不到十分钟，它就开始行动了——先是从自己专用的狗门钻出去，不到五分钟就带回来三只邻居家的狗。</p><p>接下来就是一场"世纪派对"：沙发上的抱枕全部被扔到地上、茶几上的杂志变成了碎片、厨房垃圾桶被翻了个底朝天。最搞笑的是，这只哈士奇还试图打开冰箱门"请客吃饭"！</p><p>主人通过手机监控看到这一切的时候，整个人都不好了。但回家后看到一群狗子排排坐、用无辜眼神看着自己的样子，又忍不住笑了出来。</p><p>评论区热评："这不是哈士奇，这是拆迁办主任！"</p>',
    isHot: true,
    isNew: false,
  },
  {
    id: 'video-6',
    title: '第一次约会紧张到说不出话，女生主动牵手的瞬间太甜了',
    slug: 'diyici-yuehui-jinzhang',
    description: '两个腼腆的人第一次约会，男生紧张得手心冒汗，女生勇敢地主动牵起了他的手。这个瞬间被朋友偷拍下来，甜度爆表！',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20shy%20young%20Chinese%20couple%20on%20first%20date%20at%20a%20cute%20cafe%2C%20girl%20gently%20reaching%20for%20boy%20hand%20across%20the%20table%2C%20blushing%20expressions%2C%20warm%20coffee%20shop%20ambiance%2C%20soft%20morning%20light%2C%20sweet%20romantic%20moment%2C%20clean%20simple%20interior%2C%20natural%20candid%20photography&width=800&height=450&seq=video-cover-06&orientation=landscape',
    category: '甜蜜互动',
    categorySlug: 'tianmi-hudong',
    tags: ['约会', '初恋', '甜蜜', '牵手'],
    author: '爱情故事馆',
    publishDate: '2026-08-05',
    viewCount: 215600,
    likeCount: 75600,
    duration: '03:10',
    contentHtml: '<p>这是两个人第一次正式约会。男生提前半小时就到了咖啡馆，把菜单看了十几遍，就是想提前准备好推荐给女生。</p><p>女生来了之后，两个人都超级紧张，对话一度陷入了尴尬的沉默。男生不停地喝水，手心全是汗。就在这时，女生突然伸出手，轻轻握住了男生的手，说："其实我也很紧张，但是和你在一起很开心。"</p><p>男生的脸瞬间红了，但嘴角忍不住上扬。朋友在隔壁桌偷拍到了这个画面，分享出来之后火遍了全网。大家都在说："这才是初恋最纯粹的样子啊！"</p>',
    isHot: false,
    isNew: true,
  },
  {
    id: 'video-7',
    title: '外卖小哥的暖心举动刷屏了！雨天的这个细节太感人',
    slug: 'waimai-xiaoge-nuanxin',
    description: '暴雨天，一位外卖小哥的举动让无数网友破防。他不仅准时送达，还用身体护住了外卖。看到最后眼泪控制不住了。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20food%20delivery%20rider%20in%20rain%20carefully%20protecting%20food%20bag%20with%20his%20raincoat%2C%20rainy%20city%20street%20at%20night%2C%20warm%20streetlight%20glow%2C%20touching%20moment%20of%20everyday%20kindness%2C%20reflective%20wet%20pavement%2C%20clean%20urban%20scene%2C%20emotional%20storytelling%20photography%2C%20soft%20rain%20atmosphere&width=800&height=450&seq=video-cover-07&orientation=landscape',
    category: '情感故事',
    categorySlug: 'qinggan-gushi',
    tags: ['外卖小哥', '暖心', '感动', '正能量'],
    author: '温暖人间',
    publishDate: '2026-08-04',
    viewCount: 523400,
    likeCount: 198700,
    duration: '02:45',
    contentHtml: '<p>那天暴雨如注，一位顾客点了外卖。因为天气太恶劣，顾客都做好了迟到的心理准备。但是外卖小哥不仅准时送达了，而且外卖包装几乎没有淋湿。</p><p>原来，小哥把自己的雨衣脱下来裹在了外卖袋子上，自己却全身湿透了。顾客看到这一幕，赶紧拿毛巾给小哥擦雨水，还非要给他一个好评和打赏。</p><p>小哥笑着说："没事没事，您趁热吃，别凉了。"然后转身又冲进了雨里，继续送下一单。</p><p>这个视频被楼上的邻居拍下来发到网上，瞬间刷屏。大家都在说：每一个认真生活的人都值得被温柔以待。</p>',
    isHot: true,
    isNew: false,
  },
  {
    id: 'video-8',
    title: '同事生日变求婚现场，全办公室都哭了',
    slug: 'tongshi-shengri-bianqiuhun',
    description: '本以为是普通的同事生日聚会，结果变成了超浪漫的求婚现场！男生提前和全公司串通好，女生完全被蒙在鼓里，反应太真实了！',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20surprise%20marriage%20proposal%20in%20a%20modern%20office%20decorated%20with%20balloons%20and%20flowers%2C%20man%20kneeling%20with%20ring%2C%20woman%20covering%20mouth%20in%20surprise%2C%20coworkers%20cheering%20around%2C%20warm%20indoor%20lighting%2C%20joyful%20celebration%20moment%2C%20clean%20workspace%2C%20emotional%20reaction%2C%20bright%20natural%20light%20from%20windows&width=800&height=450&seq=video-cover-08&orientation=landscape',
    category: '甜蜜互动',
    categorySlug: 'tianmi-hudong',
    tags: ['求婚', '办公室', '惊喜', '浪漫'],
    author: '爱情故事馆',
    publishDate: '2026-08-03',
    viewCount: 341200,
    likeCount: 112300,
    duration: '06:18',
    contentHtml: '<p>女生以为这只是一个普通的同事生日聚会，还准备了礼物。推开门的一瞬间，看到满办公室的气球和花瓣，她还以为是给同事准备的惊喜。</p><p>直到同事们纷纷让开，她看到男朋友穿着西装拿着戒指跪在地上，才意识到——原来今天的主角是自己！女生的表情从困惑到震惊再到泪流满面，整个过程被同事们的手机全部记录了下来。</p><p>最感人的是男生的求婚词："从我们在这家公司认识的第一天起，我就知道你是我想共度一生的人。这三年来，每天和你一起上下班是我最幸福的时光。嫁给我好吗？"</p><p>整个办公室掌声雷动，连平时最严肃的老板都偷偷抹眼泪了。这大概就是传说中的"办公室恋情天花板"吧！</p>',
    isHot: false,
    isNew: true,
  },
  {
    id: 'video-9',
    title: '金毛把自己的饭分给流浪猫，善良的狗狗让人泪目',
    slug: 'jinmao-fenfan-geiliulangmao',
    description: '一只金毛在吃饭时发现门口有只流浪猫，它居然叼着自己的饭盆放到猫咪面前！这个举动让主人当场愣住，太暖了！',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20golden%20retriever%20gently%20pushing%20its%20food%20bowl%20toward%20a%20small%20stray%20cat%20at%20a%20doorway%2C%20heartwarming%20animal%20kindness%20scene%2C%20warm%20afternoon%20sunlight%2C%20clean%20home%20entrance%2C%20touching%20interspecies%20friendship%2C%20soft%20natural%20lighting%2C%20simple%20background%2C%20emotional%20moment&width=800&height=450&seq=video-cover-09&orientation=landscape',
    category: '搞怪萌宠',
    categorySlug: 'gaoguai-mengchong',
    tags: ['金毛', '流浪猫', '暖心', '动物友谊'],
    author: '萌宠大本营',
    publishDate: '2026-08-02',
    viewCount: 478900,
    likeCount: 187200,
    duration: '03:40',
    contentHtml: '<p>主人正在给金毛准备晚餐，突然发现门口蹲着一只瘦弱的流浪猫。还没等主人反应过来，金毛做了一个让所有人都意想不到的举动。</p><p>它轻轻地用鼻子推着自己的饭盆，一路推到门口，然后退后两步，摇着尾巴看着流浪猫，好像在说："吃吧，我知道你饿了。"</p><p>流浪猫一开始很警惕，但看到金毛友善的样子，慢慢走过来开始吃了起来。金毛就安静地趴在旁边，像守护着小伙伴一样。</p><p>主人说，从那天起，这只流浪猫每天都会来，金毛也每次都把自己的饭分一半给它。现在主人已经正式收养了这只猫咪，两个小家伙成了最好的朋友。</p>',
    isHot: true,
    isNew: false,
  },
  {
    id: 'video-10',
    title: '异地男友突然出现在课堂上，女生的反应甜炸了',
    slug: 'yidi-nanyou-ketang-jingxi',
    description: '女生在课堂上认真听讲，完全不知道异地男友已经悄悄坐到了她后面。当老师点名让她回答问题时，惊喜从天而降！',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20university%20classroom%20scene%2C%20a%20young%20Chinese%20woman%20turning%20around%20in%20surprise%20to%20see%20her%20boyfriend%20sitting%20behind%20her%2C%20joyful%20shocked%20expression%2C%20classmates%20smiling%2C%20bright%20classroom%20with%20natural%20light%20from%20windows%2C%20clean%20modern%20education%20setting%2C%20warm%20candid%20moment&width=800&height=450&seq=video-cover-10&orientation=landscape',
    category: '恋爱日常',
    categorySlug: 'lianai-richang',
    tags: ['异地恋', '惊喜', '校园', '甜蜜'],
    author: '甜蜜小剧场',
    publishDate: '2026-08-01',
    viewCount: 298700,
    likeCount: 93400,
    duration: '04:05',
    contentHtml: '<p>异地恋最难熬的就是想见却见不到。这对情侣已经两个月没见面了，男生决定给女朋友一个超级惊喜——悄悄飞到她的城市，混进她的课堂！</p><p>男生提前联系了女生的闺蜜，拿到了课程表。当天他戴着口罩和帽子，偷偷坐到了教室最后一排。女生在前面认真听讲，完全没发现。</p><p>老师点名让女生回答问题，她站起来回答完之后，后排突然传来一个熟悉的声音："回答得真好！"女生回头一看，整个人都愣住了，然后尖叫着冲过去抱住了男朋友。</p><p>全班同学都在起哄鼓掌，连老师都笑着说"今天这节课就到这里吧"。这场面甜到让人想谈恋爱！</p>',
    isHot: false,
    isNew: true,
  },
  {
    id: 'video-11',
    title: '爸爸第一次给女儿扎辫子，成果让妈妈笑到扶墙',
    slug: 'baba-gei-nver-zhabianzi',
    description: '妈妈出差，爸爸负责照顾女儿。第一次给女儿扎辫子的成果简直让人笑喷！但是女儿的暖心回应让所有人暖到了～',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20Chinese%20father%20struggling%20to%20tie%20his%20little%20daughter%20hair%20with%20messy%20but%20cute%20result%2C%20daughter%20giggling%20in%20mirror%2C%20morning%20sunlight%20in%20bedroom%2C%20funny%20heartwarming%20family%20scene%2C%20clean%20simple%20home%20interior%2C%20natural%20light%2C%20warm%20atmosphere&width=800&height=450&seq=video-cover-11&orientation=landscape',
    category: '趣味搞笑',
    categorySlug: 'quwei-gaoxiao',
    tags: ['爸爸带娃', '搞笑', '暖心', '亲子'],
    author: '欢乐一家人',
    publishDate: '2026-07-31',
    viewCount: 612300,
    likeCount: 234500,
    duration: '03:55',
    contentHtml: '<p>妈妈出差三天，把五岁的女儿交给了爸爸。第一天早上爸爸就遇到了大挑战——给女儿扎辫子！</p><p>爸爸看了好几个教程视频，信心满满地开始操作。结果扎出来的辫子一高一低、一松一紧，看起来就像两个完全不搭的"天线"立在头上。</p><p>妈妈通过视频看到女儿的造型，笑得趴在墙上起不来。但女儿对着镜子看了半天，然后回头对爸爸说："爸爸扎得最好看了！我明天还要爸爸扎！"</p><p>爸爸眼眶都红了。虽然他扎的辫子确实惨不忍睹，但女儿眼里的爸爸永远是满分。这就是最纯粹的爱吧！</p>',
    isHot: true,
    isNew: false,
  },
  {
    id: 'video-12',
    title: '公交车上陌生人的一次善意，改变了他的一天',
    slug: 'gongjiaoche-moshengren-shanliang',
    description: '一个年轻人因为工作压力在公交车上默默流泪，旁边阿姨的一个简单举动，让他感受到了世界的温暖。',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20young%20person%20on%20a%20city%20bus%20receiving%20a%20piece%20of%20candy%20from%20a%20kind%20elderly%20woman%20sitting%20nearby%2C%20touching%20moment%20of%20human%20kindness%2C%20warm%20sunlight%20through%20bus%20window%2C%20clean%20bus%20interior%2C%20soft%20emotional%20atmosphere%2C%20simple%20everyday%20compassion&width=800&height=450&seq=video-cover-12&orientation=landscape',
    category: '情感故事',
    categorySlug: 'qinggan-gushi',
    tags: ['暖心', '陌生人', '善意', '公交车'],
    author: '温暖人间',
    publishDate: '2026-07-30',
    viewCount: 287400,
    likeCount: 98500,
    duration: '02:30',
    contentHtml: '<p>这个年轻人那天被老板批评了，项目也被否了，感觉整个世界都在和自己作对。坐在公交车上，眼泪不知不觉就流了下来。</p><p>旁边的一位阿姨注意到了，她没有说任何话，只是默默地从包里掏出一颗糖，轻轻放在年轻人的手心里，然后拍了拍他的肩膀。</p><p>就是这么一个简单的动作，年轻人说那一瞬间他感受到了久违的温暖。一颗糖虽然不值钱，但那份来自陌生人的关怀让他重新有了力量。</p><p>下车的时候，年轻人对阿姨说了声谢谢。阿姨笑着说："年轻人，没有什么过不去的坎，吃饱了继续加油！"</p><p>这个视频的评论区变成了大型"人间温暖"分享现场，大家都在讲自己被陌生人帮助过的经历。世界或许有时候很冷漠，但总有人在偷偷温暖着你。　</p>',
    isHot: false,
    isNew: true,
  },
];

export const getVideosByCategory = (categorySlug: string): VideoArticle[] => {
  return videos.filter((v) => v.categorySlug === categorySlug);
};

export const getVideoById = (id: string): VideoArticle | undefined => {
  return videos.find((v) => v.id === id);
};

export const getHotVideos = (limit: number = 6): VideoArticle[] => {
  return videos.filter((v) => v.isHot).slice(0, limit);
};

export const getNewVideos = (limit: number = 6): VideoArticle[] => {
  return videos.filter((v) => v.isNew).slice(0, limit);
};

export const getRelatedVideos = (currentId: string, limit: number = 4): VideoArticle[] => {
  const current = getVideoById(currentId);
  if (!current) return [];
  return videos
    .filter((v) => v.id !== currentId && v.categorySlug === current.categorySlug)
    .slice(0, limit);
};